// import * as yaml from 'js-yaml';
// import * as path from 'path';

import { createWorld3, loadCatalogSpec, ObjectLoader } from '../core';

const menuRoot = {
  catalog: [
    {
      items: [
        {
          name: 'apple bran muffin',
          aliases: ['apple bran muffin', 'apple muffin'],
        },
        {
          name: 'blueberry muffin',
          aliases: ['blueberry muffin'],
        },
      ],
    },
  ],
  imports: ['foo/child.yaml'],
};

const menuChild = {
  catalog: [
    {
      items: [
        {
          name: 'lemon poppyseed muffin',
          aliases: ['lemon poppyseed muffin', 'lemon muffin'],
        },
      ],
    },
  ],
};

// export class MockLoader implements ILoader {
//   private readonly context: string[];

//   constructor(root?: string) {
//     this.context = ['.'];
//   }

//   load(name: string, push: boolean): Promise<object> {
//     // Resolve filename relative to previous file.
//     const resolved: string = path.resolve(
//       this.context[this.context.length - 1],
//       name
//     );

//     if (push) {
//       // NOTE: context is not popped when readFile() fails.
//       this.context.push(path.dirname(resolved));
//     }

//     console.log(`readFile(${resolved})`);

//     return new Promise<object>((resolve, reject) => {
//       resolve(menuRoot);
//     });
//   }

//   pop(): void {
//     this.context.pop();
//   }
// }

async function go(menufile: string) {
  const loader = new ObjectLoader([
    ['/samples/menu/menu.yaml', menuRoot],
    ['/samples/menu/foo/child.yaml', menuChild],
  ]);
  const spec = await loadCatalogSpec(loader, menufile);
  const world = createWorld3(spec);
  const catalog = world.catalog;

  for (const item of catalog.specificEntities()) {
    console.log(`${item.name} (${item.sku})`);
  }
}

go('samples/menu/menu.yaml');
